import { DateType } from '@adminPortal/_common/_enums/date-type';
import { Pipe, PipeTransform } from '@angular/core';

interface DateObject {
  type: DateType;
  dateTime?: string | null;
  offsetInDays?: number;
}

@Pipe({
  name: 'objectToDate',
  standalone: true,
})
export class ObjectToDatePipe implements PipeTransform {
  transform(
    dateObj: DateObject,
    additionalParam?: 'updateDate' | 'commentDate' | 'replyDate',
    locale?: string,
    commentData?: DateObject
  ): string | null {
    if (!dateObj || !dateObj.type) return null;

    if (dateObj.type === DateType.ABSOLUTE && dateObj.dateTime) {
      return this.handleAbsoluteDate(dateObj.dateTime, locale);
    } else if (dateObj.type === DateType.RELATIVE) {
      return this.handleRelativeDate(dateObj.offsetInDays, additionalParam, locale, commentData);
    }

    return null;
  }

  private handleAbsoluteDate(dateTime?: string, locale?: string): string | null {
    if (!dateTime) return null;

    const date = new Date(dateTime);
    if (isNaN(date.getTime())) return null;

    return date.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  private handleRelativeDate(
    offsetInDays?: number,
    additionalParam?: 'updateDate' | 'commentDate' | 'replyDate',
    locale?: string,
    commentData?: DateObject
  ): string | null {
    if (offsetInDays === undefined) return null;

    let resultDate: Date;

    if (additionalParam === 'updateDate') {
      const today = new Date();
      resultDate = new Date(today);
      resultDate.setMonth(today.getMonth() - offsetInDays);
    } else if (additionalParam === 'commentDate') {
      const today = new Date();
      resultDate = new Date(today);
      resultDate.setDate(today.getDate() - offsetInDays);
    } else if (additionalParam === 'replyDate') {
      return this.handleReplyDate(offsetInDays, commentData, locale);
    } else {
      const today = new Date();
      resultDate = new Date(today);
      resultDate.setDate(today.getDate() - offsetInDays);
    }

    return resultDate.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  private handleReplyDate(offsetInDays: number, commentData?: DateObject, locale?: string): string | null {
    if (!commentData) return null;

    let commentDate: Date;

    if (commentData.type === DateType.ABSOLUTE) {
      if (!commentData.dateTime) return null;
      commentDate = new Date(commentData.dateTime);
    } else if (commentData.type === DateType.RELATIVE) {
      if (commentData.offsetInDays === undefined) return null;
      const today = new Date();
      commentDate = new Date(today);
      commentDate.setDate(today.getDate() - commentData.offsetInDays);
    } else {
      return null;
    }

    if (isNaN(commentDate.getTime())) return null;

    const replyDate = new Date(commentDate);
    replyDate.setDate(commentDate.getDate() + offsetInDays);
    return replyDate.toLocaleDateString(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }
}
